import { graphql, useStaticQuery } from 'gatsby'
import { BusinessData } from './BusinessData'
import { ContactInfo } from './ContactInfo'
import { SiteSections } from './SiteSections'

import { ArcaplanetLogoFooter } from 'src/components/icons/ArcaplanetLogoFooter'

export const Footer = () => {
  const footer = useStaticQuery(graphql`
    query FooterQuery {
      allCmsFooter {
        nodes {
          footer {
            footerData {
              contactInfo {
                title
                telephoneSectionTitle
                telephoneNumber
                secondAddressTitle
                secondAddressValue
                secondAddressUrl
                businessHours
                businessDays
                googleLink
                appleLink
                socialLogos {
                  link
                  logoImage
                }
                businessData
              }
              footerItems {
                items {
                  label
                  labelColor
                  labelURL
                }
                title
                titleColor
              }
            }
          }
        }
      }
    }
  `)

  return (
    <footer className="flex flex-col">
      <div className="w-full 2xl:max-w-[1440px] 2xl:mx-auto">
        <div className="px-6 md:px-10">
          <div className="h-[1.8rem] w-[225px] xs:h-[2.2rem] xs:w-[272px] md:h-12 md:w-[407px] mb-[-3px]">
            <ArcaplanetLogoFooter />
          </div>
        </div>
      </div>
      <div className="bg-black">
        <div className="w-full 2xl:max-w-[1440px] 2xl:mx-auto lg:px-10">
          <div className="flex flex-col lg:flex-row lg:flex-nowrap pt-4 md:pt-6 lg:pt-0 lg:gap-6">
            <SiteSections
              sections={
                footer.allCmsFooter.nodes[0].footer.footerData.footerItems
              }
            />

            <ContactInfo
              contactInfo={
                footer.allCmsFooter.nodes[0].footer.footerData.contactInfo
              }
            />
          </div>
        </div>
      </div>
      <div className="bg-[#6C6C6C]">
        <BusinessData
          businessData={
            footer.allCmsFooter.nodes[0].footer.footerData.contactInfo
              .businessData
          }
        />
      </div>
    </footer>
  )
}

Footer.displayName = 'Footer'
